export default {
  '成绩列表':'Score List',
  '锻炼时间':'Exercise Time',
  '导出数据':'Export Data',
  '或':'Or',
  '设为无效':'Set as Invalid',
  '恢复有效':'Restore Validity',
  '视频回放':'Video Playback',
  '比赛记录':'Competition Records',
  '最佳成绩':'Best Score',
  '完成时间':'Completion Time',
  '个人榜':'Individual Ranking',
  '比赛明细':'Competition Details',
  '管理人员可通过视频情况将成绩处理为“无效”，无效的成绩不会参与任何排行，请慎重操作！':'Administrators can invalidate scores based on video verification. Invalid scores will be excluded from all rankings. Proceed with caution!',
  '请输入用户姓名，学校名模糊搜索':'Enter user name or school name for fuzzy search',
}